export const BUSINESS_FUNCTION = {
	DONOR_PORTAL_ACC_IDENTIFIER_FULL_ACCESS: 'Donor Portal: Account Identifier - Full Access',
	DONOR_PORTAL_ACC_NOTES_FULL_ACCESS: 'Donor Portal: Account Notes Only - Full Access',
	DONOR_PORTAL_BOOK_OF_BUSINESS_FULL_ACCESS: 'Donor Portal: Book of business - Full Access',
	DONOR_PORTAL_SEGMENATION_FULL_ACCESS: 'Donor Portal: Segmentation - Full Access',
	DONOR_PORTAL_STANDING_LOA_FULL_ACCESS: 'Donor Portal: Standing LOA - Full Access',
	DONOR_PORTAL_ACCESS_KEY_FULL_ACCESS: 'Donor Portal: Access Key - Full Access',
	DONOR_PORTAL_RECOMMEND_GRANT_FULL_ACCESS: 'Donor Portal: Recommend Grant - Full Access',
	DONOR_PORTAL_SUBMIT_AN_EXCHANGE_FULL_ACCESS: 'Donor Portal: Submit an Exchange - Full Access',
	DONOR_PORTAL_EDIT_SINGLE_GRANT_FULL_ACCESS: 'Donor Portal: Edit Single Grant - Full Access',
	DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS: 'Donor Portal: Edit Recurring Exchange - Full Access',
	DONOR_PORTAL_EDIT_RECURRING_GRANT_SCHEDULE_FULL_ACCESS:'Donor Portal: Edit Recurring Grant Schedule - Full Access'
}